export default class SelectedRequestMapItem {
    id = 0;
    data = null;
    constructor(_data) {
        this.id = _data.id;
        this.data = _data.address;
    }
}
